import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2Icon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Button, LinkButton } from '../../components/ui/Button';
import { useAdminData } from '../../contexts/AdminDataContext';
import { formatDateTime, telHref } from '../../utils/format';
export function Enquiries() {
  const {
    enquiries,
    dataLoading,
    createCaseFromEnquiry
  } = useAdminData();
  const navigate = useNavigate();
  const [working, setWorking] = useState<string | null>(null);
  return <div className="px-5 py-7 md:px-8 md:py-10" data-id="element-548" data-mp="muqiykllqtsf">
      <p className="text-sm text-ink-muted" data-id="element-549" data-mp="7w5071gb1y0u">Fra formularen “Fortæl om din opgave”</p>
      <h1 className="mt-1 font-display text-[clamp(1.8rem,5vw,2.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-550" data-mp="cuzrkrsc8uwk">
        Henvendelser
      </h1>

      {dataLoading && enquiries.length === 0 && <p className="mt-8 flex items-center gap-2 text-[15px] text-ink-muted" data-id="element-551" data-mp="278qxphbgkwn9">
          <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-552" data-mp="276mtszdk7xmz" />
          Henter henvendelser …
        </p>}

      <ul className="mt-7 grid gap-5" data-id="element-553" data-mp="2r9gf818kaa2">
        {enquiries.map(enquiry => <li key={enquiry.id} className="rounded-card border border-line bg-white p-5 md:p-6" data-id="element-554" data-mp="hfnpi0p8wuz2">
            <div className="flex flex-wrap items-start justify-between gap-3" data-id="element-555" data-mp="cgkkgg99mor3">
              <div data-id="element-556" data-mp="cinjfpsebs7y">
                <p className="text-xs text-ink-muted" data-id="element-557" data-mp="3kwcq7625dagt">{formatDateTime(enquiry.createdAt) || 'Netop nu'}</p>
                <h2 className="mt-1 font-display text-xl font-bold tracking-tight text-ink" data-id="element-558" data-mp="3fxjad6ze17dh">{enquiry.name}</h2>
              </div>
              <span className={`rounded-full border px-2.5 py-1 text-xs font-medium ${enquiry.status === 'Ny henvendelse' ? 'border-[#e6cfc2] bg-accent-soft text-accent-deep' : 'border-line bg-canvas text-ink-soft'}`} data-id="element-559" data-mp="3ty3qfvdx4p3a">
                {enquiry.status}
              </span>
            </div>

            <dl className="mt-4 grid gap-3 text-[15px] sm:grid-cols-3" data-id="element-560" data-mp="1t9cdo8rppho">
              <div data-id="element-561" data-mp="6t5ipu4xtt0e">
                <dt className="text-xs uppercase tracking-wider text-ink-muted" data-id="element-562" data-mp="6schf8oqzvpn">Telefon</dt>
                <dd className="mt-1 flex items-center gap-1.5 text-ink" data-id="element-563" data-mp="bs8l16tj9l4o">
                  <PhoneIcon className="h-4 w-4 text-ink-faint" aria-hidden="true" data-id="element-564" data-mp="fu3p2j2umcm5" />
                  {enquiry.phone || '—'}
                </dd>
              </div>
              <div data-id="element-565" data-mp="3fb1v39n3rru3">
                <dt className="text-xs uppercase tracking-wider text-ink-muted" data-id="element-566" data-mp="3f7e2ccphf9gf">E-mail</dt>
                <dd className="mt-1 flex items-center gap-1.5 break-all text-ink" data-id="element-567" data-mp="3k67dhyhaqodf">
                  <MailIcon className="h-4 w-4 shrink-0 text-ink-faint" aria-hidden="true" data-id="element-568" data-mp="3o8lyao4izy7c" />
                  {enquiry.email || '—'}
                </dd>
              </div>
              <div data-id="element-569" data-mp="2whob1zkxh5t9">
                <dt className="text-xs uppercase tracking-wider text-ink-muted" data-id="element-570" data-mp="2wi7op43jp81h">Adresse / område</dt>
                <dd className="mt-1 flex items-center gap-1.5 text-ink" data-id="element-571" data-mp="30ihwmmawe8iz">
                  <MapPinIcon className="h-4 w-4 text-ink-faint" aria-hidden="true" data-id="element-572" data-mp="2szqsgf717ydz" />
                  {enquiry.address || '—'}
                </dd>
              </div>
            </dl>

            <p className="mt-4 whitespace-pre-line border-t border-line pt-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-573" data-mp="2jzc57aaic97u">
              {enquiry.description}
            </p>

            {enquiry.images.length > 0 && <ul className="mt-4 grid grid-cols-3 gap-3 sm:grid-cols-5" data-id="element-574" data-mp="2a2plwpxtxq7x">
                {enquiry.images.map(image => <li key={image.path} data-id="element-575" data-mp="2594j8klak82e">
                    <a href={image.url} target="_blank" rel="noreferrer" data-id="element-576" data-mp="20bmj9jp9536j">
                      <img src={image.url} alt={image.name} className="aspect-square w-full rounded-xl object-cover" data-id="element-577" data-mp="209s0oc1gdn5m" />
                    </a>
                  </li>)}
              </ul>}

            <div className="mt-5 flex flex-wrap gap-3" data-id="element-578" data-mp="3memco6k2k9kz">
              {enquiry.caseId ? <Button variant="secondary" size="sm" onClick={() => navigate(`/admin/sager/${enquiry.caseId}`)} data-id="element-579" data-mp="3rdpktzvcivx6">
                  Åbn sagen
                </Button> : <Button size="sm" disabled={working === enquiry.id} onClick={async () => {
            setWorking(enquiry.id);
            const created = await createCaseFromEnquiry(enquiry);
            setWorking(null);
            if (created) navigate(`/admin/sager/${created.id}`);
          }} data-id="element-580" data-mp="3cmoz4t5l95j3">
                  {working === enquiry.id ? <>
                      <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-581" data-mp="2ypa9bnbfavql" />
                      Opretter …
                    </> : 'Opret sag fra henvendelse'}
                </Button>}
              {enquiry.phone && <LinkButton href={telHref(enquiry.phone)} variant="secondary" size="sm" data-id="element-582" data-mp="2hdlhywrme8gn">
                  Ring
                </LinkButton>}
              {enquiry.email && <LinkButton href={`mailto:${enquiry.email}`} variant="secondary" size="sm" data-id="element-583" data-mp="2r6txq5jwec7j">
                  Send e-mail
                </LinkButton>}
            </div>
          </li>)}
      </ul>

      {!dataLoading && enquiries.length === 0 && <p className="mt-8 rounded-card border border-dashed border-line bg-white p-10 text-center text-sm text-ink-muted" data-id="element-584" data-mp="2v62t1eul6i57">
          Der er ingen henvendelser endnu.
        </p>}
    </div>;
}